import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

const PrivateRoute = () => {
  const { usuario } = useAuth();
  const token = sessionStorage.getItem('token') || localStorage.getItem('token');
  const location = useLocation();

  return usuario || token
    ? <Outlet />
    : <Navigate to="/login" state={{ from: location }} replace />;
};

export default PrivateRoute;
